import { CardsTabs } from './CardTabs';

export type { TypeCardsTabsProps } from './types';
export default CardsTabs;
